import axios from 'axios'
import { LISTAR_FILTROS_AGENDAMENTO_VIAGEM } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosAgendamentoViagem (idEmpresa) {
  const url = `${URL}/agendamento-viagem/empresa/${idEmpresa}/filtros`

  return dispatch => axios.get(url).then(
      response => dispatch({
          type: LISTAR_FILTROS_AGENDAMENTO_VIAGEM,
        payload: response

      })
  );
}
